"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _messagePopup = _interopRequireDefault(require("../../message-popup/message-popup"));

const SupportCompletePopup = ({
  onClose
}) => /*#__PURE__*/_react.default.createElement(_messagePopup.default, {
  className: "support-popup",
  title: "Got it!",
  onClose: onClose,
  buttons: [{
    value: 'close',
    name: 'Close',
    onClick: onClose
  }]
}, "Someone from our support team will be in touch soon");

SupportCompletePopup.propTypes = {
  onClose: _propTypes.default.func.isRequired
};
var _default = SupportCompletePopup;
exports.default = _default;